import React from "react";
import {
  fromMonthly,
  toMonthly,
  fromDetail,
  toHourly
} from "fuction/date";
import { withRouter } from "react-router";
import queryString from "query-string";
import Grid from "@material-ui/core/Grid";
import Layout from "Layout";
import { Typography } from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
import DateTimePicker from "Components/DateTimePicker";
import MyPagination from "Components/MyPagination";
import OrderSelect from "Components/OrderSelect";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import Avatar from "@material-ui/core/Avatar";
import LaunchIcon from "@material-ui/icons/Launch";
import PeopleIcon from "@material-ui/icons/People";

import useApi from "Hooks/useApi";
import useAuth from "Hooks/useAuth";
import replaceTweetText from "fuction/replaceTweetText";
import { animateScroll as scroll } from 'react-scroll';
import googleAnalytics from "fuction/googleAnalytics";
import Toolbar from '@material-ui/core/Toolbar';
import { useQueryString, modQueryPageNum, getQueryPageNum } from "Hooks/useQueryString";

import "dayjs/locale/ja";
import dayjs from "dayjs";
dayjs.locale("ja");

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    marginTop: theme.spacing(2),
  },
  fixedHeight: {
    height: 240,
  },
  tweettext: {
    whiteSpace: "pre-wrap",
  },
  count: {
    fontWeight: "bold",
  },
  divider: {
    display: "flex",
    alignItems: "center",
    margin: theme.spacing(2),
  },
  formControl: {
    margin: theme.spacing(3),
    minWidth: 120,
  },
  sticky: {
    position: "-webkit-sticky", /* safari対応 */
    position: "sticky",
    top: 64,
    zIndex: 1,
    backgroundColor: "white",
    paddingRight: 90,
    width: "105%",
    marginLeft: -10,
  },
}));

function Page(props) {
  const { request, convertQueryParam } = useApi();
  const auth = useAuth();
  const classes = useStyles();
  const queryParams = useQueryString();

  const { date, id } = queryString.parse(props.location.search);

  const fromDate = fromDetail(queryString.parse(props.location.search).date);
  const toDate = toHourly(date);
  const activeGroup = auth.state.activeGroup;

  const [page, setPage] = React.useState(getQueryPageNum(queryParams));
  const [text, setText] = React.useState("");
  const [totalCount, setTotalCount] = React.useState(0);
  const [data, setData] = React.useState([]);
  const [order, setOrder] = React.useState("desc");

  const scrollToTop = () => {
    scroll.scrollToTop();
  }

  const handleDateChange = (dateTime) => {
    props.history.push(`/retweets/details?activeGroup=${activeGroup}&id=${id}&date=${dateTime}`);
  };

  const fetchData = () => {
    // 戻るボタンやURL直貼りで遷移してきたとき、queryParams と auth.state の activeGroup が食い違っていても、
    // 初回レンダでは state の activeGroup （デフォルトグループ）でリクエストして返されたデータで画面表示されてしまう。
    // Layout.js で queryParams と auth.state の activeGroup の同期をとったあとで走る再レンダ時のリクエストで
    // 後からデータを取得しても画面に反映されない（set○○(●●)までで再々レンダは走らない）ので、
    // 同期前で食い違いがあるうちはリクエストしない。
    const activeGroup = queryParams.get("activeGroup");
    if (activeGroup && auth.state.activeGroup !== parseInt(activeGroup, 10)) {
      return;
    }
    Promise.all([
      // リツイート情報取得API
      request({
        method: "GET",
        url: `data/:account_id/retweets/${
          auth.state.activeGroup
        }/statuses?${convertQueryParam({
          retweet: id,
          range: [fromDate, toDate],
          order: order,
          pagination: {
            page: page,
            limit: 50,
          },
        })}`,
      }),
    ]).then(([statuses]) => {
      setTotalCount(statuses.meta.total_count);
      setData(statuses.data);
      scrollToTop()
    });
  }

  // 話題テキスト情報を取得
  const rquestRetweetsText = () => {
    // 戻るボタンやURL直貼りで遷移してきたとき、queryParams と auth.state の activeGroup が食い違っていても、
    // 初回レンダでは state の activeGroup （デフォルトグループ）でリクエストして返されたデータで画面表示されてしまう。
    // Layout.js で queryParams と auth.state の activeGroup の同期をとったあとで走る再レンダ時のリクエストで
    // 後からデータを取得しても画面に反映されない（set○○(●●)までで再々レンダは走らない）ので、
    // 同期前で食い違いがあるうちはリクエストしない。
    const activeGroup = queryParams.get("activeGroup");
    if (activeGroup && auth.state.activeGroup !== parseInt(activeGroup, 10)) {
      return;
    }
    // 現在日時から3か月分
    const getTextFromDate = fromMonthly(dayjs().subtract(3, "month"));
    const getTextToDate = toMonthly(dayjs());

    Promise.all([
      // リツイートテキスト取得
      request({
        method: "GET",
        url: `data/:account_id/retweets/${
          auth.state.activeGroup
        }/statuses?${convertQueryParam({
          retweet: id,
          range: [getTextFromDate, getTextToDate],
          order: "desc",
          pagination: {
            page: "1",
            limit: "1",
          },
        })}`,
      }),
    ]).then(([statuses]) => {
      setText(replaceTweetText(statuses.data[0]));
    });
  }

  // 初回レンダリングフラグ
  const isFirstRender = React.useRef(false);
  React.useEffect(() => {
    // タイトル変更
    document.title = "Buzz Finder - 話題分析";
    isFirstRender.current = true;
  }, []);

  React.useEffect(() => {
    googleAnalytics(props.location.pathname, auth.state.user.account_id);
  }, [props.location.pathname]);

  React.useEffect(() => {
    // 初回レンダー判定
    if(!isFirstRender.current) {
      fetchData();
    }
  }, [page]);

  const syncQueryPageNum = (...[pn]) => {
    if ((pn && pn === 1) || (totalCount > 0 && (Math.ceil(totalCount / 50)) < getQueryPageNum(queryParams))) {
      modQueryPageNum(queryParams, 1);
      props.history.push(props.location.pathname + "?" + queryParams.toString());
      setPage(1);
    }
    else {
      setPage(getQueryPageNum(queryParams));
    }
  }

  React.useEffect(() => {
    if (auth.state.activeGroup === 0) {
      return;
    }
    // 初回レンダー判定
    if(isFirstRender.current) {
      // 初回レンダーではないように
      isFirstRender.current = false;
      // フィルター変更による取得
      fetchData();
      // 初回ツイートデータ取得
      rquestRetweetsText();
    } else {
      if (page === 1) {
        // フィルター変更による取得
        fetchData();
      } else {
        syncQueryPageNum(1);
      }
    }
  }, [auth.state.activeGroup, order, date]);

  if (page !== getQueryPageNum(queryParams)) {
    syncQueryPageNum();
  }
  return (
    <Layout
      content={
        <Grid>
          <Toolbar className={classes.sticky}>
            <Grid item xs={12}>
              <Grid
                container
                direction="row"
                alignItems="flex-end"
                justifyContent="flex-start"
              >
                <DateTimePicker
                  dateTime={fromDate}
                  handleDateChange={handleDateChange}
                  step={60}
                />
                {data.length > 0 && (
                  <>
                    <div className={classes.divider}></div>
                    <OrderSelect
                      handleChangeOrderSelect={(value) => {
                        setOrder(value);
                      }}
                      value={order}
                    />
                  </>)}
              </Grid>
              <Grid container spacing={3} className={classes.formControl} justifyContent="center">
                <MyPagination
                count={Math.ceil(totalCount / 50)}
                currentPage={page}
                handlePagination={(page) => setPage(page)}
                />
              </Grid>
            </Grid>
          </Toolbar>
          <Grid>
            <Typography className={classes.count}>{totalCount}件</Typography>
          </Grid>
          <Grid>
            <Paper className={classes.paper}>
              <Typography className={classes.tweettext}>
                {text}
              </Typography>
            </Paper>
          </Grid>
          {data.length > 0 && (
            <Grid>
              <Grid>
                <Paper className={classes.paper}>
                  <Table size="small">
                    <TableBody>
                      {data.map((row, index) => (
                        <TableRow key={index}>
                          <TableCell>
                            <Grid item>
                              <Grid container spacing={2} alignItems="center">
                                <Grid item>
                                  <Avatar
                                    alt={row.user.name}
                                    src={row.user.profile_image_url_https}
                                  />
                                </Grid>
                                <Grid item>
                                  <Typography
                                    component="p"
                                    variant="body2"
                                    color="textPrimary"
                                  >
                                    <a
                                      href={`https://twitter.com/${row.user.screen_name}`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      {row.user.name}
                                    </a>
                                  </Typography>
                                </Grid>
                                <Grid item>
                                  <Typography
                                    component="p"
                                    variant="body2"
                                    color="textPrimary"
                                  >
                                    （
                                    <a
                                      href={`https://twitter.com/${row.user.screen_name}`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      {row.user.screen_name}
                                    </a>
                                    ）
                                  </Typography>
                                </Grid>
                                <Grid item>
                                  <Link
                                    to={`/users/details?activeGroup=${activeGroup}&user=${row.user.screen_name}`}
                                  >
                                    <PeopleIcon color="primary" />
                                  </Link>
                                </Grid>
                              </Grid>
                            </Grid>
                            <Grid item>
                              <Grid
                                container
                                spacing={2}
                                alignItems="center"
                                justifyContent="flex-end"
                              >
                                <Grid item>
                                  <Typography
                                    component="p"
                                    variant="body2"
                                    color="textPrimary"
                                  >
                                    {dayjs(row.created_at).format(
                                      "YYYY/MM/DD HH:mm:ss"
                                    )}
                                  </Typography>
                                </Grid>
                                <a
                                  href={`https://twitter.com/${row.user.screen_name}/status/${row.id_str}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <Grid item>
                                    <LaunchIcon />
                                  </Grid>
                                </a>
                              </Grid>
                            </Grid>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </Paper>
              </Grid>
            </Grid>
          )}
        </Grid>
      }
    />
  );
}

export default withRouter(Page);
